import { SmartPowerSettingsDto } from 'src/Libs/smart-power/api'
import { SmartPowerSettingsModel } from 'src/Libs/smart-power/models'

const fromDtoToModelTransformer = (dto: SmartPowerSettingsDto): SmartPowerSettingsModel => ({
  emsPowerLimitsUsed: dto.emsPowerLimitsUsed,
  emsPowersaveEnabled: dto.emsPowersaveEnabled,
  emsMaxChargePower: dto.emsMaxChargePower,
  emsMaxDischargePower: dto.emsMaxDischargePower,
  emsDischargeStartPower: dto.emsDischargeStartPower,
  emsSysSpec: {
    maxChargePower: dto.emsSysSpec.maxChargePower,
    maxDischargePower: dto.emsSysSpec.maxDischargePower,
    maxStartDischargePower: dto.emsSysSpec.maxStartDischargePower,
    minStartDischargePower: dto.emsSysSpec.minStartDischargePower,
  },
})

export default fromDtoToModelTransformer
